baseIsMap